import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m17.978 12.529-.05.06-2.77 2.76c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1.53-1.54h-9.08c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.08l-1.53-1.54a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.78 2.78.04.04c.3.3.3.76 0 1.06" fill="currentColor"/>' }
  })
);